// Module
var code = "<ticket-project-status ng-class=\"{ 'inactive': $ctrl.currentStatus.id === 0, 'with-labels': $ctrl.showLabels }\"> <st-ticket-project-status-picker status=\"::$ctrl.currentStatus\" statuses=\"::$ctrl.availableStatuses\" on-pick=\"::$ctrl.onStatusPicked(status)\"></st-ticket-project-status-picker> </ticket-project-status> ";
// Exports
module.exports = code;